import { _ } from "~/i18n";
import { IRouteConst } from "./const";
import ParamsItemSelectItem from "./params/item.select.item";

export const NEW_CRITERIONS = {
	WALK: {
		SMOOTH: 133,
		RUN: 134,
	},
	BIKE: {
		CYCLO_TURIST: 121,
		ROAD: 122,
		MTB: 123,
		GRAVEL_TREKING: 124,
		SCOOTER: 125,
	},
	SKI: {
		SKI_ALPS: 142,
	},
};
export const PREMIUM_CRITERIONS: Array<number> = [
	NEW_CRITERIONS.WALK.SMOOTH,
	NEW_CRITERIONS.WALK.RUN,
	NEW_CRITERIONS.BIKE.GRAVEL_TREKING,
	NEW_CRITERIONS.BIKE.SCOOTER,
	NEW_CRITERIONS.SKI.SKI_ALPS,
];

interface ISetRouteConst {
	routeConst: IRouteConst;
	state: boolean;
}

export function setRouteConstPremium({
	routeConst,
	state = false,
}: ISetRouteConst) {
	if (state) {
		/** moznosti */
		routeConst.types.car.subItems.push({
			type: "car-options",
			name: "car-options",
		});

		// pesi - feraty
		routeConst.types.trial.subItems[0].items.push({
			label: _("route.params.walkTuristFerratas"),
			value: {
				// turisticka
				criterion: 132,
				allowViaFerrata: true,
			},
			premium: true,
		});
		routeConst.types.trial.subItems[0].items.push({
			label: _("route.params.walkRun"),
			value: NEW_CRITERIONS.WALK.RUN,
			premium: true,
		});
		routeConst.types.trial.subItems[0].items.push({
			label: _("route.params.walkWithStroller"),
			value: NEW_CRITERIONS.WALK.SMOOTH,
			premium: true,
		});
		routeConst.types.trial.criterion.push(NEW_CRITERIONS.WALK.SMOOTH);
		routeConst.types.trial.criterion.push(NEW_CRITERIONS.WALK.RUN);

		// kolo
		const bikeItem = routeConst.types.bike.subItems[0];

		// zmena ID, titulku
		bikeItem.items[0].label = _("route.params.criterionBikeDef");
		bikeItem.items[0].value = NEW_CRITERIONS.BIKE.CYCLO_TURIST;
		routeConst.types.bike.def = NEW_CRITERIONS.BIKE.CYCLO_TURIST;

		const lastItem = bikeItem.items.pop();

		bikeItem.items.push({
			label: _("route.params.criterionBike1"),
			value: NEW_CRITERIONS.BIKE.MTB,
		});
		bikeItem.items.push(lastItem);
		bikeItem.items.push({
			label: _("route.params.criterionBike3"),
			value: NEW_CRITERIONS.BIKE.GRAVEL_TREKING,
			premium: true,
		});
		bikeItem.items.push({
			label: _("route.params.criterionBike4"),
			value: NEW_CRITERIONS.BIKE.SCOOTER,
			premium: true,
		});

		routeConst.types.bike.criterion.push(NEW_CRITERIONS.BIKE.CYCLO_TURIST, NEW_CRITERIONS.BIKE.MTB, NEW_CRITERIONS.BIKE.GRAVEL_TREKING, NEW_CRITERIONS.BIKE.SCOOTER);
		// bezky
		routeConst.types.ski.subItems = [{
			type: "select",
			name: "route-ski-type",
			variable: "criterion",
			items: [{
				label: _("route.params.criterionSki1"),
				selected: true,
				value: 141,
			}, {
				label: _("route.params.criterionSki2"),
				value: NEW_CRITERIONS.SKI.SKI_ALPS,
				premium: true,
			}],
			itemFactory: (item, userIsPremium) => new ParamsItemSelectItem(item, userIsPremium),
		}];
		routeConst.types.ski.criterion.push(NEW_CRITERIONS.SKI.SKI_ALPS);
	} else {
		routeConst.types.car.subItems.push({
			label: _("route.params.tollOption"),
			type: "toll",
			name: "route-toll",
			constant: 1,
		});
	}
}

interface IRouteParams {
	criterion?: number;
	allowViaFerrata?: boolean;
	avoidHighways?: boolean;
}

export function isRouteReadOnly(isUserPremium: boolean, routeParams: IRouteParams) {
	if (Mapy.CUS?.route?.anotherCriterion) {
		const criterion = routeParams.criterion || 0;

		return isUserPremium
			? false
			: PREMIUM_CRITERIONS.includes(criterion) || routeParams.allowViaFerrata || routeParams.avoidHighways;
	}

	return false;
}
